<template>
  <div>
    <GlobalSearchMobile v-if="show_search"/>
    <div class="banner-container" :style="`background-image: url(${image})`">

    </div>
    <MenuMobile :icon="true" :nav="true" :show_user="show_user"></MenuMobile>
  </div>
</template>

<script>

export default {
  props: {
    image: {
      type: String,
      default: ''
    },
    show_user: {
      type: Boolean,
      default: false
    },
    show_search: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  },
  mounted() {

  }
}
</script>
